import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { WrappedFieldProps } from 'redux-form';

const styles = makeStyles<Theme, WrappedFieldProps>(theme => ({
  error: {
    bottom: theme.spacing(-3),
    position: 'absolute',
    right: 0,
  },
  formControl: {
    '&.small': {
      width: theme.spacing(5),
    },
    position: 'relative',
    width: '100%',
  },
  header: {
    marginBottom: theme.spacing(0.5),
  },
  iconButton: {
    padding: 0,
  },
  input: {
    '&.centered': {
      textAlign: 'center',
    },
    '&::placeholder': {
      color: theme.palette.common.gray600,
      opacity: 1,
    },
    '&[type="number"]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&[type="number"]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    fontSize: '0.875rem',
  },
  root: {
    '&.small': {
      padding: theme.spacing(1.5, 1, 1.5, 1),
    },
    backgroundColor: theme.palette.common.white,
    border: props => {
      const { active, valid, touched } = props.meta;

      if (active) return theme.customBorders.primary;
      if (!valid && touched) return theme.customBorders.error;
      return theme.customBorders.gray200;
    },
    borderRadius: theme.spacing(0.5),
    height: theme.spacing(5),

    padding: theme.spacing(1.5, 2, 1.5, 2),
    transition: 'border-color 0.3s ease',
    width: '100%',
  },
}));

export default styles;
